import React from "react";
import PropTypes from "prop-types";

/**
 * Komponent uniwersalny Wrapper
 * Tworzy kontener z klasami i strukturą HTML
 *
 * @param {string} classes - Dodatkowe klasy CSS dla kontenera.
 * @param {React.ReactNode} children - Elementy renderowane wewnątrz kontenera.
 * @returns {JSX.Element}
 */
const Wrapper = ({ classes = "", children }) => {
    return (
        <div className={`container ${classes}`}>
            <div className="row">
                <div className="col-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};

Wrapper.propTypes = {
    classes: PropTypes.string, // Dodatkowe klasy CSS
    children: PropTypes.node.isRequired, // Elementy do wyrenderowania w środku
};

export default Wrapper;
